const prod_na_fallback_url = 'https://d3a3saarspcyfn.cloudfront.net';

window.__AAC_CHROME_REMOTE_URLS__ = window.__AAC_CHROME_REMOTE_URLS__ || {
  bellDrawer: prod_na_fallback_url,
};

window.__AAC_CHROME_REMOTE_URLS__.bellDrawer =
  window.__AAC_CHROME_REMOTE_URLS__.bellDrawer || prod_na_fallback_url;
